<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-robot-outline
      </v-icon>AI Credits
    </h2>
    <v-tabs
      v-model="activeTab"
      color="#37474F"
      background-color="transparent"
    >
      <v-tab>Overview</v-tab>
      <v-tab>Purchase Requests</v-tab>
    </v-tabs>
    <br>
    <div v-show="activeTab === 0">
      <v-card
        shaped
        color="#CFD8DC"
      >
        <br>
        <v-card-title>
          <v-row>
            <v-col
              cols="12"
              lg="6"
            >
              <v-autocomplete
                v-model="selectedOrganizationId"
                menu-props="auto"
                :items="organizationList"
                item-value="external_id"
                item-text="name"
                label="Select Organization"
                outlined
                dense
                @input="getAiCredits()"
              />
            </v-col>
            <v-spacer />
            <v-col
              cols="12"
              lg="4"
              class="text-right"
            >
              <v-btn
                color="#FF3700"
                :disabled="!selectedOrganizationId"
                @click="showForm = true"
              >
                <v-icon
                  left
                  dark
                >
                  mdi-plus
                </v-icon>
                Adjust Credits
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <div v-if="!selectedOrganizationId">
          <v-card-text class="text-center">
            Please select an organization to view AI credit details.
          </v-card-text>
        </div>
        <div v-else>
          <v-row class="px-4">
            <v-col
              cols="6"
              md="2"
            >
              <v-card
                outlined
                class="pa-3 text-center stat-card"
              >
                <div class="stat-label">
                  Total Credits
                </div>
                <div class="stat-value">
                  {{ aiCredits.total_credits }}
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="2"
            >
              <v-card
                outlined
                class="pa-3 text-center stat-card"
              >
                <div class="stat-label">
                  Used Credits
                </div>
                <div class="stat-value">
                  {{ aiCredits.used_credits }}
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="2"
            >
              <v-card
                outlined
                class="pa-3 text-center stat-card"
              >
                <div class="stat-label">
                  Remaining Credits
                </div>
                <div class="stat-value">
                  {{ aiCredits.remaining_credits }}
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="3"
            >
              <v-card
                outlined
                class="pa-3 text-center stat-card"
              >
                <div class="stat-label">
                  Remaining Value (AUD)
                </div>
                <div class="stat-value">
                  {{ aiCredits.remaining_value_aud }}
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="3"
            >
              <v-card
                outlined
                class="pa-3 text-center stat-card"
              >
                <div class="stat-label">
                  Credit Value (AUD)
                </div>
                <div class="stat-value">
                  {{ aiCredits.credit_value_aud }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <br>
          <h3 class="sub-title-style">
            Usage
          </h3>
          <v-row class="px-4">
            <v-col
              cols="6"
              md="4"
            >
              <v-card
                outlined
                class="pa-3 text-center stat-card"
              >
                <div class="stat-label">
                  Requests
                </div>
                <div class="stat-value">
                  {{ usage.requests }}
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="4"
            >
              <v-card
                outlined
                class="pa-3 text-center stat-card"
              >
                <div class="stat-label">
                  Total Tokens
                </div>
                <div class="stat-value">
                  {{ usage.total_tokens }}
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="4"
            >
              <v-card
                outlined
                class="pa-3 text-center stat-card"
              >
                <div class="stat-label">
                  Cost (USD)
                </div>
                <div class="stat-value">
                  {{ usage.cost_usd }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <br>
          <h3 class="sub-title-style">
            Usage By Feature
          </h3>
          <v-data-table
            :headers="featureHeaders"
            :items="aiCredits.by_feature || []"
            disable-sort
            disable-pagination
            hide-default-footer
            class="elevation-1"
            mobile-breakpoint="100"
          >
            <template #item="{ item }">
              <tr>
                <td>{{ item.feature_type }}</td>
                <td>{{ item.requests }}</td>
                <td>{{ item.credits_used }}</td>
              </tr>
            </template>
          </v-data-table>
          <div class="py-3" />
        </div>
      </v-card>
      <adjust-ai-credits
        v-if="showForm"
        :organization-id="selectedOrganizationId"
        @closed="showForm=false"
        @fetch-ai-credits="getAiCredits()"
      />
    </div>
    <div v-show="activeTab === 1">
      <ai-credit-purchase-requests />
    </div>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import AdjustAiCredits from 'src/views/dashboard/payments/AiCredits/AdjustAiCredits.vue';
  import AiCreditPurchaseRequests from 'src/views/dashboard/payments/AiCredits/AiCreditPurchaseRequests.vue';

  export default {
    name: 'AiCredits',
    components: {
      'centre-spinner': spinner,
      'adjust-ai-credits': AdjustAiCredits,
      'ai-credit-purchase-requests': AiCreditPurchaseRequests,
    },
    data () {
      return {
        loading: false,
        activeTab: 0,
        selectedOrganizationId: '',
        showForm: false,
        featureHeaders: [
          { text: 'Feature', align: 'start', value: 'feature_type' },
          { text: 'Requests', value: 'requests' },
          { text: 'Credits Used', value: 'credits_used' },
        ],
      };
    },
    computed: {
      aiCredits () {
        return this.$store.getters['payments/getAiCredits'];
      },
      usage () {
        return this.aiCredits.usage || {};
      },
      organizationList () {
        return this.$store.getters['organizations/getOrganizationList'];
      },
    },
    async mounted () {
      await this.getOrganizationsList();
      if (this.organizationList.length > 0) {
        this.selectedOrganizationId = this.organizationList[0].external_id;
        await this.getAiCredits();
      }
    },
    methods: {
      async getOrganizationsList () {
        this.loading = true;
        await this.$store.dispatch('organizations/fetchOrganizationList');
        this.loading = false;
      },
      async getAiCredits () {
        if (!this.selectedOrganizationId) {
          return;
        }
        this.loading = true;
        await this.$store.dispatch('payments/fetchAiCredits', {
          organizationId: this.selectedOrganizationId,
        });
        this.loading = false;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.sub-title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.stat-card {
  background-color: #ECEFF1;
}
.stat-label {
  font-size: 12px;
  color: #37474F;
  font-weight: bold;
  text-transform: uppercase;
}
.stat-value {
  font-size: 20px;
  color: #37474F;
  font-weight: bold;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
</style>
